import React from "react";
import Banner from "../../components/Banner";
import Footer from "../../components/Footer";
import { Sidebar } from "../../components/Sidebar";
import axios from "axios";
import Spinner from "../../components/Spinner";

const API = localStorage.getItem("assethost");

export default class SearchAsset extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      valid: true,
      msg: "",
      toastColor: "",
      assets: [],
      category: "",
      uniqueIdentifier: "",
      assetFile: null,
      categories: [],
      searchCost: null,
      errors: {},
      companyProfileId: sessionStorage.getItem("companyProfileId") || "0",
      individualProfileId: sessionStorage.getItem("individualProfileId") || "0",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleUploadSearch = this.handleUploadSearch.bind(this);
    this.validate = this.validate.bind(this);
    this.loadCategories = this.loadCategories.bind(this);
  }

  componentDidMount() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
    this.loadCategories(token);
  }

  loadCategories(token) {
    this.setState({ loading: true, msg: "", toastColor: "" });
    const individualProfileId =
      sessionStorage.getItem("individualProfileId") || "0";
    const companyProfileId = sessionStorage.getItem("companyProfileId") || "0";

    axios
      .get(
        API +
          `/asset/getassetgenericsearchdropdownlist/${individualProfileId}/${companyProfileId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        const data = response.data || {};
        this.setState({
          categories: data.categories || [],
          searchCost: data.searchCost || null,
          loading: false,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          loading: false,
          msg: error?.response?.data?.message || "Failed to load categories.",
          toastColor: "danger",
        });
      });
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value }, this.validate);
  }

  handleFileChange(e) {
    const { name } = e.target;
    const file = e.target.files ? e.target.files[0] : null;
    this.setState({ [name]: file, errors: {} });
  }

  validate() {
    const s = this.state;
    let errors = {};
    let valid = true;

    if (!s.category || !s.category.trim()) {
      errors.category = "Category is required";
      valid = false;
    }
    if (!s.uniqueIdentifier || !s.uniqueIdentifier.trim()) {
      errors.uniqueIdentifier = "Unique identifier is required";
      valid = false;
    }

    this.setState({ errors, valid });
    return valid;
  }

  handleSearch(e) {
    e.preventDefault();
    if (!this.validate()) {
      if (!this.state.category || !this.state.uniqueIdentifier) {
        this.setState({
          msg: "Both category and unique identifier are needed for this search",
          toastColor: "danger",
        });
      }
      return;
    }

    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    this.setState({ loading: true, msg: "", toastColor: "" });

    let request = {
      categoryName: this.state.category,
      uniqueIdentifier: this.state.uniqueIdentifier,
      companyProfileId: parseInt(this.state.companyProfileId) || 0,
      individualProfileId: parseInt(this.state.individualProfileId) || 0,
      searchCost: this.state.searchCost || 0,
    };

    axios
      .post(API + "/asset/search", request, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        this.setState({
          assets: response.data || [],
          loading: false,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          assets: [],
          loading: false,
          msg:
            error?.response?.data?.message ||
            "Search failed. Please try again.",
          toastColor: "danger",
        });
      });
  }

  handleUploadSearch(e) {
    e.preventDefault();
    if (!this.state.assetFile) {
      this.setState({
        msg: "Please select a file to upload.",
        toastColor: "danger",
      });
      return;
    }

    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    this.setState({ loading: true, msg: "", toastColor: "" });

    let request = new FormData();
    request.append("file", this.state.assetFile);
    if (Number(sessionStorage.getItem("companyProfileId"))) {
      request.companyProfileId = sessionStorage.getItem("companyProfileId");
    }
    if (Number(sessionStorage.getItem("individualProfileId"))) {
      request.individualProfileId = sessionStorage.getItem(
        "individualProfileId"
      );
    }
    if (Number(sessionStorage.getItem("lawEnforcementProfileId"))) {
      request.lawEnforcementProfileId = sessionStorage.getItem(
        "lawEnforcementProfileId"
      );
    }

    axios
      .post(API + "/asset/searchupload", request, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data.success) {
          this.setState({
            assets: response.data.assetGenericViews || [],
            loading: false,
          });
        } else {
          this.setState({
            assets: response.data.assetGenericViews || [],
            loading: false,
            errors: { assetFile: response.data.message || "Failed to search" },
            toastColor: "danger",
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          assets: [],
          loading: false,
          msg:
            error?.response?.data?.message ||
            "Upload search failed. Please try again.",
          toastColor: "danger",
        });
      });
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.loading) {
      return <Spinner className="" />;
    }

    return (
      <div className="min-h-screen flex justify-between bg-white">
        <Sidebar />
        <div className="min-h-screen w-[85%] flex flex-col">
          <Banner title="Search Asset" />
          {divMsg}
          <div className="w-full grow px-5 flex flex-col justify-start">
            <div className="w-full ">
              <form
                className="grid grid-cols-12 w-full gap-2 mt-2"
                autoComplete="off"
              >
                <div className="input-group col-span-5">
                  <label className="input-group-text">Category</label>
                  <select
                    name="category"
                    className="form-control"
                    value={s.category}
                    onChange={this.handleChange}
                  >
                    <option value="">Select</option>
                    {s.categories.map((cat, index) => (
                      <option key={index} value={cat}>
                        {cat}
                      </option>
                    ))}
                  </select>
                  {s.errors.category && (
                    <span className="input-group-error">
                      {s.errors.category}
                    </span>
                  )}
                </div>
                <div className="input-group col-span-5">
                  <label className="input-group-text">Unique Identifier</label>
                  <input
                    name="uniqueIdentifier"
                    className="form-control"
                    type="text"
                    value={s.uniqueIdentifier}
                    onChange={this.handleChange}
                    placeholder="Enter unique identifier"
                  />
                  {s.errors.uniqueIdentifier && (
                    <span className="input-group-error">
                      {s.errors.uniqueIdentifier}
                    </span>
                  )}
                </div>
                <button
                  type="button"
                  className="btn btn-success col-span-2"
                  onClick={this.handleSearch}
                >
                  Search
                </button>
                <span className="col-span-full font-bold text-danger">
                  * For search with file, put unique identifier in first column,
                  without headers
                </span>
                <div className="input-group col-span-8">
                  <label className="input-group-text">Asset Search File</label>
                  <input
                    name="assetFile"
                    className="form-control"
                    type="file"
                    onChange={this.handleFileChange}
                    accept=".xlsx"
                  />
                  {s.errors.assetFile && (
                    <span className="input-group-error">
                      {s.errors.assetFile}
                    </span>
                  )}
                </div>
                <button
                  type="button"
                  className="btn btn-success col-span-2"
                  onClick={this.handleUploadSearch}
                  disabled={!s.assetFile}
                >
                  Upload & Search
                </button>

                {s.errors.search && (
                  <div className="alert alert-danger mx-7 mb-4 col-span-full">
                    {s.errors.search}
                  </div>
                )}
              </form>

              {s.assets.length > 0 && (
                <div className="w-full overflow-x-auto border mt-6">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Category
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Unique Identifier
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Status
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Make
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Model
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Ownership
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {s.assets.map((asset) => (
                        <tr
                          key={`asset-${asset.id}`}
                          className="hover:bg-gray-50"
                        >
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            {asset.categoryName || "-"}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            {asset.uniqueIdentifier || "-"}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            {asset.primaryStatus || "-"}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            {asset.primaryName || "-"}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            {asset.secondaryName || "-"}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            {asset.ownershipName || "-"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {s.assets.length > 0 && (
                <div className="flex justify-center mt-6"></div>
              )}

              {s.assets.length === 0 && s.msg === "" && (
                <div className="text-gray-500 text-center py-8">
                  No search results found. Use the search form above to find
                  assets.
                </div>
              )}
            </div>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}
